var React = require('react');

function SliderArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M20 12H4m0 0 6-6m-6 6 6 6"}));
}

SliderArrow.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = SliderArrow;

SliderArrow.default = SliderArrow;
